import React from 'react'

function Banner() {
  //change in styyle.css to reflect changes
  const style = {
    position: 'relative',
    zIndex: '-1',
    background: 'transparent url(../new-images/home-banner/home-banner1.webp) right top no - repeat',
    paddingTop: '300px',
    paddingBottom: '300px',
    textAlign: 'center',
    backgroundPosition: 'center',
    backgroundSize: '100 % 100 %',
  }
  return (
    <div className="">
      {/* <div id="homebanner" className="carousel slide" data-ride="carousel">
    <ul className="carousel-indicators">
      <li data-target="#homebanner" data-slide-to={0} className="active" />
      <li data-target="#homebanner" data-slide-to={1} />
      <li data-target="#homebanner" data-slide-to={2} />
      <li data-target="#homebanner" data-slide-to={3} />
      <li data-target="#homebanner" data-slide-to={4} />
    </ul>
    <div className="carousel-inner">
      <div className="carousel-item active">
        <img
          src="assets/img/all-banner/new/Al-banner.webp"
          alt="Web Designing Company"
          className="desktop-image"
        />
        <img
          src="assets/img/all-banner/Al-banner-mobile.webp"
          alt="Web Development Company"
          className="mobile-image"
        />
      </div>
      <div className="carousel-item">
        <img
          src="assets/img/all-banner/new/Al-banner-2.webp"
          alt="Digital Marketing Company"
          className="desktop-image"
        />
        <img
          src="assets/img/all-banner/Al-banner-2-mobile.webp"
          alt="Mobile App Development Company"
          className="mobile-image"
        />
      </div>
      <div className="carousel-item">
        <img
          src="assets/img/all-banner/block-chain-banner.webp"
          alt="Company"
          className="desktop-image"
        />
        <img
          src="assets/img/all-banner/block-chain-banner-m.webp"
          alt="Mobile App Development Company"
          className="mobile-image"
        />
      </div>
      <div className="carousel-item">
        <img
          src="assets/img/all-banner/new/Al-banner-4.webp"
          alt="Digital Marketing Company"
          className="desktop-image"
        />
        <img
          src="assets/img/all-banner/Al-banner-2-mobile.webp"
          alt="Mobile App Development Company"
          className="mobile-image"
        />
      </div>
      <div className="carousel-item">
        <img
          src="assets/img/all-banner/3d-randring.webp"
          alt="Company"
          className="desktop-image"
        />
        <img
          src="assets/img/all-banner/3d-randring-m.webp"
          alt="Mobile App Development Company"
          className="mobile-image"
        />
      </div>
    </div>
    <a className="carousel-control-prev" href="#homebanner" data-slide="prev">
      {" "}
      <span className="carousel-control-prev-icon" />
    </a>
    <a className="carousel-control-next" href="#homebanner" data-slide="next">
      {" "}
      <span className="carousel-control-next-icon" />
    </a>
  </div> */}


      {/* Stattic Banner  */}

      {/* <div className="home-banner" style={style}>
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container" style={{ marginLeft: "5%" }}>
              <div className="banner-text">

                <h2 style={{
                  fontWeight: "800px",
                  color: "white",
                  float: "left"
                }}>
                Empowering Your Digital Journey
                </h2>
                <h1 style={{
                  fontWeight: "800px",
                  color: "white",
                  float: "left"

                }}>Tech Excellence for Tomorrow's Success</h1>
                <p style={{
                  fontWeight: "800px",
                  color: "white",
                  float: "left"

                }}>Expert Web and Mobile Development Services. <br/> Elevate Your Online Presence in Web Development and Mobile Apps for Exceptional User Engagement and Business Growth</p>
              </div>
            </div>
          </div>
        </div>

      </div> */}

      <div className="home-video">
        <video autoPlay muted loop src="assets/video/alobha_banner_video.mp4" style={{width:"100%"}}></video>
      </div>


    </div>

  )
}

export default Banner